export default {
  getQuestions(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/quiz/questions?limit=1000")
        .then(response => {
          context.commit("setQuestions", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getAnswers(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/quiz/answers?limit=1000")
        .then(response => {
          context.commit("setAnswers", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  postAnswers(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/quiz/answers", data)
        .then(resolve)
        .catch(reject);
    });
  },
  updateAnswers(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/quiz/answers/bulk_update", data)
        .then(resolve)
        .catch(reject);
    });
  }
};
